module.exports = __webpack_public_path__ + "static/img/service-h5.bb7f74a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/service-h5.png
// module id = IDh3
// module chunks = 34